export const DATE_PICKER_DAY_WIDTH = 'calc(100% / 7)';
